import { createContext, useContext, ReactNode } from "react";
import { AuthContextProps } from "./types";
import { TokenStorage } from "@shared/handle-local-storage";
import { usePersonMe } from "@/services/queries/usePerson";

const AuthContext = createContext<AuthContextProps | undefined>(undefined)

export function AuthContextProvider({ children }: { children: ReactNode }) {
  const isLogado = localStorage.getItem("auth_token") !== null;

  const { refetch, data, isLoading } = usePersonMe({ enabled: isLogado })

  const logout = () => {
    TokenStorage.remove()
  }

  return (
    <AuthContext.Provider value={{
      getAuthenticatedUser: refetch,
      logout,
      person: data,
      isLoading,
      isAuthenticated: !!data
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = () => {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error("useAuthContext só pode ser utilizado dentro de um AuthContextProvider")
  }

  return context
}
